import React from "react"
import { IconButton as MuiIconButton, IconButtonProps } from "@mui/material"

export type PrimitiveIconButtonProps = IconButtonProps

export const PrimitiveIconButton = (props: PrimitiveIconButtonProps) => {
	return <MuiIconButton {...props} />
}
